"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enums = require("../enums");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'PrizeItem',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return JSON.parse(JSON.stringify(_enums.taskItem));
      }
    },
    index: {
      type: Number,
      default: 0
    },
    isAuto: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    adList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      taskTypeOptions: _enums.taskTypeOptions
    };
  },
  computed: {},
  methods: {
    modalPicTap: function modalPicTap() {
      var _this = this;
      if (_this.disabled) return;
      this.$modalUpload(function (img) {
        if (!img) return;
        _this.value.prizePic = img[0].sattDir;
      }, false, 'content');
    }
  }
};